import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { RootState } from 'app/reducer';
import { Product } from 'app/entity/product/productTypes';

import ProductPassportBase from './ProductPassportBase';

interface OwnProps {
  product: Product;
  variant?: 'widget' | 'sm' | 'md' | 'lg' | 'xl';
  customProductUrl?: string;
  disableLink?: boolean;
  onTitleClick?: () => void;
}

const ProductPassport = (props: OwnProps) => {
  const {
    product,
    variant = 'sm',
    customProductUrl,
    disableLink,
    onTitleClick = () => {},
  } = props;

  const {
    slug: productSlug,
    categoryId,
    name,
    rating,
    reviewsCount,
    logo,
    claimed,
  } = product;

  const categoriesById = useSelector(
    (state: RootState) => state.product.productCategoriesById,
  );
  const categorySlug = get(categoriesById, `${categoryId}.slug`, null);
  const as = categorySlug ? `/reviews/${categorySlug}/${productSlug}` : '';
  const productUrl = disableLink ? '' : customProductUrl || as;

  return (
    <ProductPassportBase
      title={name}
      imageUrl={logo}
      productUrl={productUrl}
      rating={rating}
      reviewsCount={reviewsCount}
      claimed={claimed}
      variant={variant}
      onTitleClick={onTitleClick}
    />
  );
};

export default ProductPassport;
